module.exports = __webpack_public_path__ + "static/media/santa-fe-hero.284ba115.webp";